import SweetAlert from "./alert";
import React, { Component } from "react";
import { browserHistory } from 'react-router'
class responseHandlerClass  extends Component {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this); 
  }

  async ResponseHandler(response, action = "reload",page="") {
    if (response?.status == 201 || response?.status == 200) {
      await SweetAlert({
        type: "success",
        title: "Success",
        text: response?.data?.message,
      });
      if (action === "goBack") {
        this.goBack()
      } 
      else if (action === "navToPage") {
        window.location.href = page;
      }
      else if (action === null) {
        action = null;
      }
       else {
        window.location.reload();
      }
    }
    else {
      await SweetAlert({
        type: "error",
        title: "Error",
        text: "Something went wrong. Please try again!",
      });
    }
  }

  ErrorHandler(error) {
    let err_msg = "Something went wrong!";
    if (typeof error.response?.data?.error !== "undefined") {
      err_msg = error.response?.data?.error;
    }
    SweetAlert({ type: "error", title: "Error", text: err_msg });
  }

  Information(msg) {
    SweetAlert({ type: "info",  title: "", text: msg });
  }

  Error(msg) {
    SweetAlert({ type: "error",  title: "Error", text: msg });
  }
  goBack(){
    this.props.history.goBack();
}
}
const resp = new responseHandlerClass();
export { resp };
